module.exports = __webpack_public_path__ + "static/3-05853ee60bbba7d708c0cea0c4b0e7b5.webp";